<template>
  <Modal
    :styles="{
      maxWidth: '832px'
    }"
    width="auto"
    v-model="visible"
    :title="title"
    :closable="false"
    :mask-closable="false"
    @on-cancel="onCancel"
    @on-ok="saveAsImg"
  >
    <sign-canvas
      class="sign-canvas"
      ref="SignCanvas"
      :options="options"
      v-model="value"
    />
    <!-- 空canvas对象，用于判断是否签名 -->
    <canvas id="sign-canvas" hidden></canvas>

    <div slot="footer">
      <Button @click="onCancel">{{ $t('btn.cancel') }}</Button>
      <Button type="warning" @click="canvasClear">{{ $t('btn.clear') }}</Button>
      <Button type="primary" @click="saveAsImg">{{ $t('btn.done') }}</Button>
    </div>
  </Modal>
</template>

<script>
import SignCanvas from 'sign-canvas';
export default {
  data() {
    return {
      visible: false,
      title: null,
      value: null,
      options: {
        isDpr: false, //是否使用dpr兼容高倍屏 [Boolean] 可选
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 2, //下笔的宽度 [Number] 可选
        lineCap: 'round', //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
        lineJoin: 'bevel', //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: 800, //canvas宽高 [Number] 可选
        canvasHeight: 400, //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        bgColor: '#fff', //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: '#ff787f', //网格颜色  [String] 可选
        writeWidth: 5, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 5, // 写字模式最小线宽  [Number] 可选
        writeColor: '#101010', // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: 'png' //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      }
    };
  },
  components: {
    SignCanvas
  },
  methods: {
    open(name) {
      const w = document.documentElement.clientWidth;
      if (w < 768) {
        this.options.canvasWidth = w - 32;
        this.options.canvasHeight = w / 2;
      }
      this.title = name;
      this.visible = true;
    },
    onCancel() {
      this.visible = false;
      this.canvasClear();
    },
    /**
     * 清除画板
     */
    canvasClear() {
      this.$refs.SignCanvas.canvasClear();
    },
    isCanvasBlank() {
      const sign = document.querySelector('.sign-canvas');
      const blank = document.getElementById('sign-canvas'); //系统获取一个空canvas对象
      console.log(sign);
      console.log(blank);
      blank.width = sign.width;
      blank.height = sign.height;
      return sign.toDataURL() === blank.toDataURL(); //比较值相等则为空
    },
    /**
     * 保存图片
     */
    saveAsImg() {
      if (this.isCanvasBlank()) {
        this.$Message.error(this.$t('global.signEmpty'));
      } else {
        const img = this.$refs.SignCanvas.saveAsImg();
        this.$emit('on-ok', img);
        this.onCancel();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.sign-canvas {
  border: 1px solid #ff787f;
}
</style>
